export const SHOW_LOADING = 'ux.SHOW_LOADING';
export const HIDE_LOADING = 'ux.HIDE_LOADING';
export const SHOW_CONFIRM = 'ux.SHOW_CONFIRM';
export const HIDE_CONFIRM = 'ux.HIDE_CONFIRM';
export const SHOW_ASYNC_LOADING = 'ux.SHOW_ASYNC_LOADING';
export const HIDE_ASYNC_LOADING = 'ux.HIDE_ASYNC_LOADING';
